import { useState, useCallback, useEffect } from 'react'
import { useLocation, useHistory } from 'react-router-dom'
import debounce from 'lodash/debounce'
import queryString from 'qs'

function useSearch(initialSearch = '') {
  const location = useLocation()
  const history = useHistory()
  // initialize search from URL
  const params = queryString.parse(location.search, { ignoreQueryPrefix: true })
  const [search, setSearch] = useState<string>((params.search as string) || initialSearch)

  const debounceSearch = useCallback(debounce(onSearch, 1000), [])

  // useEffect(() => {
  //   // whenever `search` changes, update the URL
  //   const newParams = { ...params, search }
  //   console.log('teeeeeeeeeeeest')
  //   console.log(newParams)
  //   if (search) {
  //     history.replace({
  //       pathname: location.pathname,
  //       search: queryString.stringify(newParams),
  //     })
  //   } else {
  //     history.replace({
  //       pathname: location.pathname,
  //     })
  //   }
  // }, [search])

  return [search, debounceSearch] as const

  function onSearch(value: string) {
    setSearch(value)
  }
}

export default useSearch
